(function () {
  console.log('external-link-utm.js')
  var utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  var urlParams = new URLSearchParams(window.location.search);

  // Store UTM parameters in session storage
  utmParams.forEach(function (param) {
    if (urlParams.has(param)) {
      sessionStorage.setItem(param, urlParams.get(param));
    }
  });
})();

document.addEventListener('DOMContentLoaded', function () {
  console.log('addEventListener');
  var utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  var utmString = '';

  // Retrieve stored UTM parameters from session storage
  utmParams.forEach(function (param) {
    var value = sessionStorage.getItem(param);
    if (value) {
      utmString += param + '=' + encodeURIComponent(value) + '&';
    }
  });

  // If UTM parameters exist, append them to outbound links
  if (utmString) {
    var links = document.querySelectorAll('a[href^="https://harborone-web.oflows.net"]');
    links.forEach(function (link) {
      var url = new URL(link.href);
      url.search += (url.search ? '&' : '?') + utmString.slice(0, -1); // Remove trailing &
      link.href = url.toString();
    });
  }
});
